import { render } from "./Claim4_For.vue?vue&type=template&id=be12ef28&scoped=true"
import script from "./Claim4_For.vue?vue&type=script&lang=js"
export * from "./Claim4_For.vue?vue&type=script&lang=js"

import "./Claim4_For.vue?vue&type=style&index=0&id=be12ef28&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-be12ef28"

export default script